<tec-list-layout>
	<tec-title-group [title]="'ACTIVITY.TITLE' | translate" [tooltip]="'ACTIVITY.TOOLTIP' | translate" />

	<ng-container content>
		@if (alertError) {
		<tec-alert status="error" [msg]="alertError" (closeAlert)="alertError = ''" />
		}

		<tec-table-filter [selection]="{ all: false, ids: [] }">
			<tec-toolbar [toolbar]="toolbar()" [maxFilter]="10" (formFilter)="filterChange($event)" />
			<tec-table
				[headers]="header"
				[rows]="content"
				[config]="config"
				(sortEvent)="sortChange($event)"
				(paginationChange)="paginationChange($event)"
			/>
		</tec-table-filter>
	</ng-container>
</tec-list-layout>

@if (showDetail && activitySelected) {
<app-activity-detail [uuid]="activitySelected.uuid" [initialData]="activitySelected" (closeEvent)="closeDetail()" />
}
